let apiConfig: ApiConfig | null = null;

export type ApiConfig = {
  readonly addressLookupApiUrl?: string;
  readonly basketsApiUrl?: string;
  readonly eventsApiUrl?: string;
  readonly kycApiUrl?: string;
  readonly ledgerApiUrl?: string;
  readonly loeApiUrl?: string;
  readonly ordersApiUrl?: string;
  readonly shopsApiUrl?: string;
  readonly userManagementApiUrl?: string;
  readonly officeApiUrl?: string;
  readonly profileApiUrl?: string;
  readonly registrationApiUrl?: string;
  readonly coreDataApiUrl?: string;
  readonly payoutsApiUrl?: string;
  readonly notificationApiUrl?: string;
  readonly paymentsApiUrl?: string;
  readonly paymentsUiUrl?: string;
  readonly pdfProcessorApi?: string;
};

export function initializeApiConfig(config: ApiConfig): void {
  apiConfig = config;
}

export function getApiConfig(): ApiConfig {
  if (!apiConfig) {
    throw new Error(
      'API config not initialized. Call initializeApiConfig() at app startup.',
    );
  }
  return apiConfig;
}
